import type { UtilityContext } from '@change-corgi/core/react/utilityContext';

import {
	TotalUserCount,
	type TotalUserCountQuery,
	type TotalUserCountQueryVariables,
} from './getTotalUserCount.graphql';

export type TotalUserCountResponse = { count: number; localizedCount: string };

export async function getTotalUserCount({
	gql: { fetch },
}: UtilityContext): Promise<TotalUserCountResponse | undefined> {
	const { data } = await fetch<TotalUserCountQuery, TotalUserCountQueryVariables>({
		query: TotalUserCount,
		rejectOnError: true,
	});
	return {
		count: data.getTotalUserCount.total,
		localizedCount: data.getTotalUserCount.totalLocalized,
	};
}
